import { render } from "./TheStyle.vue?vue&type=template&id=3e0c49da&ts=true"
import script from "./TheStyle.vue?vue&type=script&lang=ts"
export * from "./TheStyle.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__